<template>
    <div class="row">
        <div class="col">
            <span>{{item.start | moment('timezone',timezone,'HH:mm')}} - {{item.end | moment('timezone',timezone,'HH:mm')}}</span>
        </div>
        <div class="col">
            <button class="tasks__item__remove button alert pull-right"
                    @click="$emit('remove')"
            >
                <i class="fa fa-times"></i>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomTimeItems',
    props: {
        timezone: {
            type: String,
        },
        index: {
            type: Number
        },
        item: {
            type: Object
        }
    }
}
</script>

<style scoped>

</style>
